import type { HoursType } from "@/storage/stores";
import { ref } from "vue";

export const arrayPlanning = ref<HoursType[]>([])